export const customObjectsUsage = "/custom_objects/custom_objects_usage";
